import React from 'react';
import { useSelector } from 'react-redux';
import { Icon } from '@vds/icons';
import { ButtonIcon } from '@vds/button-icons';
import { dynamicImageUrl, getCardFormatText, resourceTypeMapping, formatEventDate ,getSuggestionData} from '../../../../utility/utils.js'; // Adjust path
import {contentClick} from "../../../../common/Analytics/GAWrapper.jsx";
const SearchResultItemCard = ({ item, recText }) => {
  const isRecordedEvent = Array.isArray(item?.topics) && item.topics.some(topic => topic.toLowerCase() === 'recorded event');
  const getdynamicImageUrl = dynamicImageUrl(item, item.thumbnail, 'search_results', 'schCarousel');
  const { getFormatText } = getCardFormatText('classic');
  const displayFormat = getFormatText(item);
  const aisearchJsonData = useSelector((state) => state?.Aem?.aemAiSearchData);
  const mappedResource = resourceTypeMapping(item, aisearchJsonData, window.location.origin);
  let finalLaunchUrl = mappedResource?.redirectUrl;
  let isEvent = false;
  if(item?.type.toLowerCase() == 'course'){
    if(item?.format?.toLowerCase() === 'blended' || item?.format?.toLowerCase() === 'classroom'){
      isEvent = true;
    }
  }
  const category = (item?.format || '').toLowerCase();
  const displayLabel = getAemLable(item);

  let timeText = category.includes('quick tips') 
    ? (item?.qtdt || '0 minutes') 
    : ( item?.duration 
        ? item.duration 
        : '0 minutes');

  function getAemLable(item) {
    if (!item) return ''; 
    const categoryOrType = (item?.type || '').toLowerCase();
    const defaultFormat = item?.format;
    if(categoryOrType.includes('course')){
      if (defaultFormat === 'Blended') {
        return aisearchJsonData?.typeaheadCardsMapping?.events?.eyebrowText || 'Virtual event';
      } else if(defaultFormat === 'Classroom') {
        return aisearchJsonData?.typeaheadCardsMapping?.inPersonEvents?.eyebrowText || 'In-person event';
      } else if (isRecordedEvent) {
        return 'Event';
      } else {
        return aisearchJsonData?.typeaheadCardsMapping?.courses?.eyebrowText  || 'Course';
      }
    } else if (categoryOrType.includes('article')) {
      return aisearchJsonData?.typeaheadCardsMapping?.categoryquicktips?.label  || 'Quick tip';
    } else if (categoryOrType.includes('learningprogram')) {
      return aisearchJsonData?.typeaheadCardsMapping?.learningProgram?.eyebrowText  || 'Learning path';
    }
    return defaultFormat;
  };
  const courseId = item?.id;
   const newSuggestionsData = getSuggestionData();
  const courseCxAemData = useSelector((state) => {
    if (isEvent) {
      return state.Aem?.eventCxJsonData; // Replace with your actual state key for virtual events
    }
    
    return state.Aem?.courseCxJsonData;
  });
  console.log('courseCxAemData', courseCxAemData);
  let courseTags = [];
  console.log('newSuggestionsData?.courses', newSuggestionsData);
  
  // 1. Fetch course tags
  for (let cItem in newSuggestionsData?.courses) {
    if (cItem === courseId) {
      console.log("found id"  , cItem, "courseId", courseId);
      courseTags = newSuggestionsData?.courses[cItem]?.tags;
    }
  }

  // 2. Fetch event tags
  for (let eItem in newSuggestionsData?.events) {
    if (eItem === courseId) {
      console.log("found id courseId"  , eItem, "courseId", courseId);
      courseTags = newSuggestionsData?.events[eItem]?.tags;
    }
  }
  
  // 3. Fetch in-person event tags
  for (let ipItem in newSuggestionsData?.inPersonEvents) {
    if (ipItem === courseId) {
      courseTags = newSuggestionsData?.inPersonEvents[ipItem]?.tags;
    }
  }

  for (let ipItem in newSuggestionsData?.inPersonEvents) {
    if (ipItem === courseId) {
      courseTags = newSuggestionsData?.inPersonEvents[ipItem]?.tags;
    }
  }

  for (let ipItem in newSuggestionsData?.learningProgram) {
    if (ipItem === courseId) {
      courseTags = newSuggestionsData?.learningProgram[ipItem]?.tags;
    }
  }

  // 4. NEW: Fetch Quick Tip tags from localStorage
  const isQuickTip = category.includes('quick tips') || item?.format?.toLowerCase() === 'quick tip';
  if (isQuickTip) {
    try {
      const allQuicktipsData = JSON.parse(localStorage.getItem('allQuicktipsData')) || [];
      const matchedQuickTip = allQuicktipsData.find((qt) => String(qt.qtid) === String(item?.id));
      
      if (matchedQuickTip && matchedQuickTip.tags) {
        courseTags = matchedQuickTip.tags;
        console.log('Found QuickTip tags in localStorage:', courseTags);
      }
    } catch (error) {
      console.error('Error parsing allQuicktipsData from localStorage:', error);
    }
  }

  console.log('courseCxAemData', courseCxAemData, 'courseTags', courseTags);
  
 if (courseCxAemData?.allTopics?.allTopicsData && courseTags != null) {
  let allTopicsData = [];
  let allTopicsObj = {};

  // 1. Normalize AEM topics (lowercase, remove spaces)
  courseCxAemData.allTopics.allTopicsData.forEach((aemItem) => {
    if (aemItem.value) {
      const normalizedValue = aemItem.value.toLowerCase().split(' ').join('');
      allTopicsData.push(normalizedValue);
      allTopicsObj[normalizedValue] = aemItem.label;
    }
  });
console.log('allTopicsData', allTopicsData, "allTopicsObj", allTopicsObj, "courseTags", courseTags);
  // 2. Map and match the course tags
  let matchedTags = [];
  courseTags.forEach(topic => {
    if (topic) {
      const normalizedTopic = topic.toLowerCase().split(' ').join('');
      if (allTopicsData.includes(normalizedTopic)) {
        matchedTags.push(allTopicsObj[normalizedTopic]);
        console.log('Matched topic:', topic, 'to label:', allTopicsObj[normalizedTopic]);
      }
    }
  });

  // 3. Assign the matched, correctly formatted labels back
  courseTags = matchedTags;
}

if (!finalLaunchUrl && item?.launchUrl) {
    try {
      const parsedRawUrl = new URL(item.launchUrl);
      finalLaunchUrl = window.location.origin + parsedRawUrl.pathname + parsedRawUrl.search + parsedRawUrl.hash;
    } catch (e) {
      finalLaunchUrl = window.location.origin + (item.launchUrl.startsWith('/') ? '' : '/') + item.launchUrl;
    }
  }
  return (
    <div className='search-result-card pointer'
      onClick={() => {
        if (finalLaunchUrl) {
          console.log('courseTags  click',courseTags);
          window.open(finalLaunchUrl, '_blank');
           contentClick(
          item?.title,
          finalLaunchUrl,
          courseTags?.filter(Boolean)?.sort()?.join(', '),
          'classic_search_details_page',
        );
        }
      }}>
      <div className='image-icons width-fill-avilable'>
          {/* <span className='search-result-badge body-sm font-eTX-bold '>
            {recText}
          </span> */}
      </div>

      {/* Render the dynamically fetched image here */}
      <div className='image'>
        <img src={getdynamicImageUrl} alt='' />
      </div>

      <div className='search-description pa-4X'>
        <div className='label wrapWord mb-3X'>
          <div className='course-label'>
            <span className='micro font-eTX-bold'>
              {displayLabel}
            </span>
            {displayFormat != '' && item?.type !== "learningProgram" && !isRecordedEvent && <span className='dot-wrap'></span>}
            {displayFormat != '' && item?.type !== "learningProgram" && !isRecordedEvent && (
              <span className='micro'>{displayFormat}</span>
            )}
          </div>
        </div>

        <div className='title-label  label mb-3X'>
          <h3 className='search-result-title title-md'>
            {item.title}
          </h3>
        </div>

        <div className='durations mt-auto'>
          <div className='textarea'>
            <div className='duration-text'>
              {(isEvent && item?.date) ? (
                       <>
                           <i className='fs-4X vds-icon icon-calendar_blk color-secondary'/>
                           <div className='vds-micro font-eTX-bold color-secondary'> 
                               {formatEventDate(item.date)}
                           </div>
                       </>
                    ) : (
                       <>
                            <Icon name='timer' size='small' color='#716F6D' />
                           <span className='ml-1X micro font-eTX-bold '>
                              {timeText}
                            </span>
                       </>
                    )}
            </div>
            <div>
              <ButtonIcon
                // kind='ghost'
                size='medium'
                ariaLabel={`View ${item.title}`}
                renderIcon={() => (
                  <Icon name='right-arrow' />
                )}
                onClick={() => {
                  if (finalLaunchUrl) {
                    window.open(finalLaunchUrl, '_blank'); 
                    }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchResultItemCard;